import React, { Component } from 'react';
import Radium from 'radium';
import { connect } from 'react-redux';
import { routeActions } from 'redux-simple-router';
import * as actions from './actions';
import ProjectCard from './ProjectCard';
import Waves from 'node-waves';
import { calcCompletedHours, calcOverAllocation } from '../../Util/overAllocation';
import { daysDiff } from '../../Util/dateTime';
import PageSpinner from '../../Common/pageSpinner';
import { Scrollbars } from 'react-custom-scrollbars';

import auth from '../../Login/authService'

class ProjectDashboard extends Component {
  componentWillMount = () => {
    this.props.dispatch(actions.fetchProjects(true));
  };

  componentDidMount = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };

  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };

  scrollButtom = (evt) => {
    if (evt.top === 1) {
      this.props.dispatch(actions.fetchProjects());
    }
  };

  toggleFavorite = (showFavorites) => {
    this.props.dispatch(actions.fetchProjects());
    this.props.dispatch(actions.setShowFavorites(showFavorites));
  };

  render() {
    const { projects, dispatch, isLoading, showFavorites } = this.props;

    let cardNodes = []
    let warningCards = []
    let dangerCards = []

    const role = auth.getProfile().role;

    projects.forEach((project, index) => {
      if (project.favorite === showFavorites || showFavorites === false)
        if (project.summary) {
          var completedHrs = calcCompletedHours(project.summary.estimatedSum, project.summary.percent);
          var overAllocation = calcOverAllocation(completedHrs, project.summary.totalHours);
          var lastUpdate = new Date(project.summary.lastModified);
          var difference = daysDiff(lastUpdate);

          if (difference <= -7) {
            warningCards.push((
              <div key={project.id} style={styles.cardContainer} className="col-sm-6 col-md-4 col-lg-4">
                <ProjectCard
                  {...project}
                  editContact={(contact, oldContact, contactIndex) => { dispatch(actions.editContact(index, project.id, contact, oldContact, contactIndex)) }}
                  createContact={(contact) => { dispatch(actions.createContact(index, project.id, contact)) }}
                  updateFavorite={(favorite) => { dispatch(actions.updateFavorite(index, project.id, favorite)) }}
                  projectId={project.id}
                  role={role}
                  overAllocation={overAllocation}
                  lastUpdate={lastUpdate}
                  difference={difference}
                />
              </div>
            ))
          }
          else if (overAllocation < 0) {
            dangerCards.push((
              <div key={project.id} style={styles.cardContainer} className="col-sm-6 col-md-4 col-lg-4">
                <ProjectCard
                  {...project}
                  editContact={(contact, oldContact, contactIndex) => { dispatch(actions.editContact(index, project.id, contact, oldContact, contactIndex)) }}
                  createContact={(contact) => { dispatch(actions.createContact(index, project.id, contact)) }}
                  updateFavorite={(favorite) => { dispatch(actions.updateFavorite(index, project.id, favorite)) }}
                  projectId={project.id}
                  role={role}
                  overAllocation={overAllocation}
                  lastUpdate={lastUpdate}
                  difference={difference}
                />
              </div>
            ))
          }
          else {
            cardNodes.push((
              <div key={project.id} style={styles.cardContainer} className="col-sm-6 col-md-4 col-lg-4">
                <ProjectCard
                  {...project}
                  editContact={(contact, oldContact, contactIndex) => { dispatch(actions.editContact(index, project.id, contact, oldContact, contactIndex)) }}
                  createContact={(contact) => { dispatch(actions.createContact(index, project.id, contact)) }}
                  updateFavorite={(favorite) => { dispatch(actions.updateFavorite(index, project.id, favorite)) }}
                  projectId={project.id}
                  role={role}
                  overAllocation={overAllocation}
                  lastUpdate={lastUpdate}
                  difference={difference}
                />
              </div>
            ))
          }
        }
        else {
          cardNodes.push((
            <div key={project.id} style={styles.cardContainer} className="col-sm-6 col-md-4 col-lg-4">
              <ProjectCard
                {...project}
                editContact={(contact, oldContact, contactIndex) => { dispatch(actions.editContact(index, project.id, contact, oldContact, contactIndex)) }}
                createContact={(contact) => { dispatch(actions.createContact(index, project.id, contact)) }}
                updateFavorite={(favorite) => { dispatch(actions.updateFavorite(index, project.id, favorite)) }}
                projectId={project.id}
                role={role}
              />
            </div>
          ))
        }
    })

    // Create one array for all the cards  (Warning -> Danger -> Normal, order)
    let finalCardNodes = warningCards.concat(dangerCards, cardNodes);
    return (
      <div className="row" style={styles.container}>
        <div className="col-xs-12 text-right" style={styles.filterBtnsContainer}>
          {role !== 'Formand' ?
            <div className="btn btn-primary waves-btn"
              style={styles.opretsag}
              onClick={() => {
                this.props.dispatch(routeActions.push('/tilbud/opretsag'))
              }}>
              Opret ny
              </div> : null
          }
          Vis
            <div className={showFavorites ? "btn btn-default waves-btn" : "btn btn-info waves-btn"}
            onClick={() => this.toggleFavorite(false)}
            style={styles.seeAll}>
            Alle
            </div>
          <div className={showFavorites ? "btn btn-info waves-btn" : "btn btn-default waves-btn"}
            onClick={() => this.toggleFavorite(true)}
            style={styles.seeFavorite}>
            Favoritter
            </div>
        </div>
        {isLoading && finalCardNodes.length === 0 ?
          <PageSpinner />
          :
          <Scrollbars ref="scrollBar" onScrollFrame={this.scrollButtom}>
            <div className="col-xs-12">
              <div>
                {
                  finalCardNodes.length > 0 ?
                    finalCardNodes
                    :
                    <div style={styles.emptyState}>
                      <img style={styles.emptyState.img} src="/images/emptyStates/projectCardsNoFavourites.gif" alt="Ingen favoritter tilføjet" />
                    </div>
                }
              </div>
            </div>
          </Scrollbars>
        }
      </div>
    );
  }
}

var styles = {
  container: {
    position: 'absolute',
    top: '0',
    left: '0',
    padding: '100px 0 0 0',
    width: '100%',
    height: '100%',
    marginRight: 'auto',
    marginLeft: 'auto',
    '@media (min-width: 1200px)': {
      maxWidth: '1170px',
      left: '50%',
      marginLeft: '-585px'
    }
  },
  cardContainer: {
    marginTop: '-12px'
  },
  filterBtnsContainer: {
    paddingRight: '24px',
    position: 'absolute',
    top: '50px',
    paddingTop: '8px'
  },
  seeAll: {
    width: '50px',
    height: '35px',
    lineHeight: '35px',
    padding: '0px',
    marginLeft: '15px',
    borderTopRightRadius: '0px',
    borderTopLeftRadius: '2px',
    borderBottomLeftRadius: '2px',
    borderBottomRightRadius: '0px'
  },
  seeFavorite: {
    width: '100px',
    height: '35px',
    lineHeight: '35px',
    padding: '0px',
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '2px',
    borderBottomRightRadius: '2px',
    borderBottomLeftRadius: '0px'
  },
  emptyState: {
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    marginTop: '100px',
    img: {
      borderRadius: '2px'
    }
  },
  opretsag: {
    float: 'left',
    width: '90px',
    borderRadius: '2px',
    height: '35px',
    lineHeight: '35px',
    padding: '0px',
    marginLeft: '12px'
  }
}

const selectProps = state => {
  return {
    ...state.projectDashboardReducer
  };
}

export default connect(selectProps)(Radium(ProjectDashboard));




// WEBPACK FOOTER //
// ./src/App/Project/Dashboard/index.jsx